import {ResultDetails} from "./result-details";
import {RichSearchList} from "../search-list/rich-search-list";

export class FulltextSearchList extends RichSearchList{

  public resultDetails: ResultDetails[];

  constructor(phrase: string, result: any, maxResultWindow: number){
    super(phrase, {
      facets: result.facets,
      filters: result.filters,
      pageHits: result.pageHits,
      pageNumber: result.pageNumber,
      pageSize: result.pageSize,
      phraseSuggest: result.phraseSuggest,
      search: result.search,
      sortField: result.sortField,
      startIndex: result.startIndex,
      totalHits: result.totalHits,
      totalPages: result.totalPages,
      moreAvailable: result.moreAvailable
    }, maxResultWindow);
    this.resultDetails = result.resultDetails;
  }
}
